import Swiper from 'swiper/bundle'

window.Swiper = Swiper
